import { usePreviewStore } from "@/stores/preview";

export const useWorkbookIdAndTableId = () => {
  const { workbookId, tableId } = usePreviewStore((state) => state);

  return {
    data: {
      workbookId: workbookId,
      tableId: tableId,
    },
    isLoading: false,
    isError: false,
  };
};
